import { __decorate, __metadata } from "tslib";
// deep imports to fix circular deps in jest
import { AppRequestMethod } from '../../request';
import { AppRequest } from '../../app-request';
import { Expose, ModelId, Model, IsString } from '../../model';
let StartSessionByLinkResponse = /*#__PURE__*/(() => {
  let StartSessionByLinkResponse = class StartSessionByLinkResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Boolean)], StartSessionByLinkResponse.prototype, "success", void 0);
  StartSessionByLinkResponse = __decorate([ModelId("StartSessionByLinkResponse") // auto-generated by generate-model-ids
  ], StartSessionByLinkResponse);
  // if successful, a signed session cookie will be written by server response.
  return StartSessionByLinkResponse;
})();
let StartSessionByLinkRequest = /*#__PURE__*/(() => {
  let StartSessionByLinkRequest = class StartSessionByLinkRequest extends Model {
    static {
      this.Response = StartSessionByLinkResponse;
    }
  };
  __decorate([Expose(), IsString(), __metadata("design:type", String)], StartSessionByLinkRequest.prototype, "sessionId", void 0);
  __decorate([Expose(), IsString(), __metadata("design:type", String)], StartSessionByLinkRequest.prototype, "loginByLinkSecret", void 0);
  StartSessionByLinkRequest = __decorate([AppRequest('access', 'session/start-by-link', {
    httpMethod: AppRequestMethod.POST,
    disallowInternal: true
  }), ModelId("StartSessionByLinkRequest") // auto-generated by generate-model-ids
  ], StartSessionByLinkRequest);
  return StartSessionByLinkRequest;
})();
export { StartSessionByLinkRequest };